import React, { useMemo, useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import accounting from "accounting";

import Checkbox from "./Checkbox";

import edit from "../img/edit.svg";
import "./place.css";

let lastVal = "";
const isValid = (val) => {
  const regexp = /^\d{0,2}?:?\d{0,2}$/;

  const [hoursStr, minutesStr] = val.split(":");

  if (!regexp.test(val)) {
    return false;
  }

  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);

  const isValidHour = (hour) =>
    Number.isInteger(hour) && hour >= 0 && hour < 24;
  const isValidMinutes = (minutes) =>
    (Number.isInteger(minutes) && hours >= 0 && hours < 24) ||
    Number.isNaN(minutes);
  if (!isValidHour(hours) || !isValidMinutes(minutes)) {
    return false;
  }

  if (minutes < 10 && Number(minutesStr[0]) > 5) {
    return false;
  }

  const valArr = val.indexOf(":") !== -1 ? val.split(":") : [val];

  // check mm and HH
  if (
    valArr[0] &&
    valArr[0].length &&
    (parseInt(valArr[0], 10) < 0 || parseInt(valArr[0], 10) > 23)
  ) {
    return false;
  }

  if (
    valArr[1] &&
    valArr[1].length &&
    (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59)
  ) {
    return false;
  }

  return true;
};

const Basket = ({
  match: {
    params: { areaId, itemId },
  },
  foodAreas,
  order,
  settings,
  setSettings,
}) => {
  const [faster, setFaster] = useState(settings.faster || false);
  const [time, setTime] = useState(settings.time || "");
  const [selfService, setSelfService] = useState(settings.selfService || false);
  const area = foodAreas.filter((area) => area.id === areaId)[0];
  const item = area.items.filter((item) => item.id === itemId)[0];

  const [price, products] = useMemo(() => {
    const foodIds = new Set((item.foods || []).map((item) => item.id));

    const products = Object.values(order).filter((value) => {
      const {
        item: { id },
      } = value;

      return foodIds.has(id);
    });

    const result = products.reduce((result, value) => {
      const { count, item } = value;

      return result + parseInt(item.price) * parseInt(count);
    }, 0);

    return [accounting.formatNumber(result, 0, " "), products];
  }, [order, item]);

  useEffect(() => {
    setSettings(faster, time, selfService);
  }, [faster, time, selfService]);

  return (
    <div className="Place">
      <header className="Place__header">
        <aside className="Place__trz">
          <h1 className="Place__head">
            <Link to="/" className="Place__logo">
              {area.name}
            </Link>
          </h1>
          <Link to="/edit" className="Place__change-tz">
            <img alt="change-profile" src={edit} />
          </Link>
        </aside>
      </header>
      <aside className="Place__restoraunt">
        <img
          className="Place__restoraunt-logo"
          alt="Fastfood logo"
          src={item.image}
        />
        <h2 className="Place__restoraunt-name">{item.name}</h2>
        <p className="Place__restoraunt-type">{item.description}</p>
      </aside>
      <div className="Place__products-wrapper">
        <ul className="Place__products">
          {(products.length &&
            products.map(({ item, count }) => (
              <li className="Place__product" key={item.id}>
                <img
                  className="Place__product-logo"
                  alt="Ordered product logo"
                  src={item.image}
                />
                <h3 className="Place__product-name">{item.name}</h3>
                <p className="Place__product-price">Цена: {item.price}</p>
                <p className="Place__product-count">x{count}</p>
              </li>
            ))) || <h3>Продуктов не выбрано</h3>}
        </ul>
        <Link
          className="Place__change-product"
          to={`/place/${areaId}/${itemId}`}
        >
          Изменить
        </Link>
      </div>
      <div className="Place__choice">
        <h3>Время:</h3>
        <div className="Place__choice-item">
          <span>Как можно быстрее</span>
          <Checkbox
            checked={faster}
            onToggle={() => {
              if (!faster) {
                setTime("");
                setFaster(true);
              }
            }}
          />
        </div>
        <div className="Place__choice-item">
          <span>Назначить</span>
          <input
            value={time}
            onFocus={() => {
              setFaster(false);
            }}
            onChange={(event) => {
              setFaster(false);

              let val = event.target.value;

              if (isValid(val)) {
                if (
                  val.length === 2 &&
                  lastVal.length !== 3 &&
                  val.indexOf(":") === -1
                ) {
                  val = val + ":";
                }

                if (val.length === 2 && lastVal.length === 3) {
                  val = val.slice(0, 1);
                }

                if (val.length > 5) {
                  return false;
                }

                lastVal = val;

                setTime(val);

                if (val.length === 5) {
                  setTime(val);
                }
              }
            }}
            onBlur={() => {
              if (time.length === 5) {
                setFaster(false);
              } else {
                setTime("");
                setFaster(true);
              }
            }}
            maxLength={5}
          />
        </div>
        <div className="Place__choice-item">
          <h3>С собой</h3>
          <Checkbox
            checked={selfService}
            onToggle={() => setSelfService(!selfService)}
          />
        </div>
        <div className="Place__choice-item">
          <h3>На месте</h3>
          <Checkbox
            checked={!selfService}
            onToggle={() => setSelfService(!selfService)}
          />
        </div>
      </div>
      <footer className="Place__footer">
        <Link
          to={`/order/${area.id}/${item.id}`}
          className={`Place__order ${!products.length &&
            "Place__order__disabled"}`}
        >
          Оплатить {price}
        </Link>
      </footer>
    </div>
  );
};

export default withRouter(Basket);
